/**
 * TargetTimes.jsx
 * Vintage and Classic target times per hill and class, straight from the
 * vctargets table (edited by the VC secretary in the Secretary portal).
 * Route: /target-times   API: /api/results/target-times
 */

import { useEffect, useState } from 'react';
import '../TargetTimes.css';

function label(capacity) {
  return capacity === 'Sidecar' ? 'Sidecars' : `${capacity}cc`;
}

export default function TargetTimes() {
  const [eras, setEras] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const previous = document.title;
    document.title = 'Target times · NHCA';
    return () => { document.title = previous; };
  }, []);

  useEffect(() => {
    let cancelled = false;
    fetch('/api/results/target-times')
      .then(async res => {
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || `HTTP ${res.status}`);
        return data;
      })
      .then(d => { if (!cancelled) setEras(d.eras); })
      .catch(e => { if (!cancelled) setError(e.message); });
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="tt-page">
      <header className="tt-head">
        <h1>Vintage &amp; Classic target times</h1>
        <p>Target time in seconds for each hill and class. A rider&apos;s Vintage/Classic championship score compares their time against these.</p>
      </header>

      {error && <p className="tt-error">Couldn&apos;t load the target times: {error}</p>}
      {!eras && !error && <p className="tt-loading">Loading…</p>}

      {eras && eras.map(era => (
        <section key={era.key} className="tt-era" aria-labelledby={`tt-${era.key}`}>
          <h2 id={`tt-${era.key}`}>{era.label}</h2>
          <div className="tt-scroll">
            <table className="tt-table">
              <thead>
                <tr>
                  <th scope="col">Hill</th>
                  {era.capacities.map(c => <th key={c} scope="col">{label(c)}</th>)}
                </tr>
              </thead>
              <tbody>
                {era.hills.map(h => (
                  <tr key={h.hill}>
                    <th scope="row">{h.hill}</th>
                    {era.capacities.map(c => (
                      <td key={c}>{h.targets[c] != null ? h.targets[c].toFixed(2) : '–'}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      ))}
    </div>
  );
}
